import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {BI_ORIGINS, getDynamicThankYouMessage} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {isHeadless} from '../../../../../../commons/selectors/environment'
import {usePageStateSelector} from '../../../hooks/state'
import c from '../../classnames.scss'
import {BackToSiteLink} from '../../common/back-to-site-link'
import {GroupCard} from '../../group-card'
import {SocialShare} from '../../social-share'
import {Container} from '../common/container'
import {Subtitle} from '../common/subtitle'
import {SuccessActions} from '../common/success-actions'
import {Title} from '../common/title'
import s from './thank-you-messages.scss'
import {ThankYouMessagesProps} from './index'

export const ThankYouMessages = ({
  thankYouPageLoaded,
  messages,
  hideAddToCalendar,
  t,
  isMember,
  showGroup,
  eventsMembersPageTitle,
  eventName,
  guestEmail,
  guestName,
}: ThankYouMessagesProps) => {
  const {addToCalendarActionLabel, shareActionLabel} = messages.confirmation
  const headless = usePageStateSelector(isHeadless)

  const {title, subtitle} = getDynamicThankYouMessage(
    {title: messages.confirmation.title, subtitle: messages.confirmation.message},
    {name: guestName, email: guestEmail, eventName},
  )

  React.useEffect(() => {
    thankYouPageLoaded()
    focusElement({selector: hookToAttributeSelector(DH.THANK_YOU_MESSAGE_TITLE)})
  }, [])

  return (
    <Container dataHook={DH.THANK_YOU_MESSAGE}>
      <div className={classNames(s.container, c.thankYouMessages, c.formLabelsFont, c.formTitleColor)}>
        <Title text={title} dataHook={DH.THANK_YOU_MESSAGE_TITLE} />
        {subtitle ? (
          <Subtitle
            lines={[
              subtitle,
              isMember && !headless
                ? t('members.rsvpThankYouMessage', {eventsMembersPageTitle, interpolation: {escapeValue: false}})
                : null,
            ]}
            dataHook={DH.THANK_YOU_MESSAGE_NOTIFICATION}
          />
        ) : null}
        <BackToSiteLink className={s.backToSite} />
        <SuccessActions
          t={t}
          className={s.successActions}
          downloadTicketsVisible={false}
          addToCalendarVisible={!hideAddToCalendar && Boolean(addToCalendarActionLabel)}
          calendarButtonText={addToCalendarActionLabel}
        />
        {showGroup ? <GroupCard className={s.group} /> : null}
        {shareActionLabel && !headless ? (
          <div className={s.share}>
            <div data-hook={DH.SOCIAL_SHARE_TITLE}>{shareActionLabel}</div>
            <div className={s.shareButtons}>
              <SocialShare t={t} page={BI_ORIGINS.THANK_YOU_PAGE} />
            </div>
          </div>
        ) : null}
      </div>
    </Container>
  )
}
